/**
 * @ngdoc directive
 * @name usersNoResults
 * @module flowingly.runner.setup
 * @description This component is used to display a message when there are no results
 * @usage
 * ```
     <users-no-results></users-no-results>
 * ``` 
 * NOTE: Minimal content for now, but this might grow
 */
(function () {
  'use strict';

  angular.module('flowingly.runner.setup').component('usersNoResults', {
    template: `<div class="list-no-results">No results.</div>`
  });
})();
